<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <!--  v-if="backRole('SM_2')" -->
        <el-button type="primary" @click="addConsumableBtnClick()" size="mini">新增易耗品</el-button>
      </div>

      <el-col class="item-input" :span="12">
        <label>搜索：</label>
        <el-input v-model="filterKey" size="mini" placeholder="你可以搜索易耗品明细名称/易耗品编号"></el-input>
      </el-col>

      <!-- <label class="label-name">所属公司：</label>
      <el-select size="small" class="organization-select" v-model="form.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select> -->
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" align="center" width="90">
      </el-table-column>
      <el-table-column prop="number" width="100" label="易耗品编号">
      </el-table-column>
      <el-table-column prop="name" label="易耗品明细" align="left">
      </el-table-column>
      <el-table-column prop="spec" label="规格型号" width="100" align="left">
      </el-table-column>
      <el-table-column prop="unit.name" width="90" label="计量单位" align="center">
      </el-table-column>
      <el-table-column prop="dl.num" label="类别编码" width="80" align="center">
      </el-table-column>
      <el-table-column prop="dl.name" label="所属类别" width="120" align="left">
      </el-table-column>

      <el-table-column label="操作" width="100" align="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑该易耗品基础资料" placement="bottom">
            <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="editConsumableBtnClick(scope.row)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除该易耗品基础资料" placement="bottom">
            <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="deleteConsumable(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 添加易耗品基础资料 -->
    <div class="pop-room" v-if="addConsumableStatus">
      <a href="javascript:;" @click="addConsumableStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <h3 class="title">新增易耗品</h3>
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="易耗品类别">
              <el-select @change="forceUpdate" size="small" filterable v-model="form.dlId" placeholder="支持搜索">
                <el-option v-for="item in dlList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="明细名称">
              <el-input size="small" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input size="small" v-model="form.spec"></el-input>
            </el-form-item>
            <el-form-item label="计量单位">
              <el-select @change="forceUpdate" size="small" filterable v-model="form.unitId" placeholder="支持搜索">
                <el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="addConsumable()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        addConsumableStatus: false,
        form: {
          depId: 2,
          dlId: "",
          name: "",
          spec: "",
          unitId: "",
          // 使ajax时候用json方式提交
          json: true,
        },
        formType: 0,
        dlList: "",
        unitList: "",

        // 列表
        loading: true,
        pageSize: 50,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        filterKey: "",
      }
    },
    mounted() {
      this.getUnitList()
      this.getDlList()
      this.getLists()
    },
    components: {},
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 获取易耗品类别
      getDlList() {
        ajax.get('/consumable/dl/list', {
          depId: 2
        }, (res) => {
          // this.loading = false
          this.dlList = res.vo.array
        })
      },
      // 获取计量单位
      getUnitList() {
        ajax.get('/storage/unit/list', '', (res) => {
          // this.loading = false
          this.unitList = res.vo.array
        })
      },
      // 编辑易耗品基础资料按钮点击
      editConsumableBtnClick(row) {
        this.addConsumableStatus = true
        this.form.consumableId = row.id
        this.form.dlId = row.dl.id
        this.form.unitId = row.unit.id
        this.form.name = row.name
        this.form.spec = row.spec
        this.formType = 1
      },
      // 新增易耗品基础资料按钮点击
      addConsumableBtnClick() {
        this.addConsumableStatus = true
        this.formType = 0;
        this.form.dlId = ""
        this.form.name = ""
        this.form.spec = ""
        this.form.unitId = ""
      },
      // 新增/编辑易耗品基础资料
      addConsumable() {
        let _url = this.formType == 0 ? '/consumable/add' : '/consumable/edit?consumableId=' + this.form.consumableId

        ajax.post(_url, this.form, (res) => {
          this.addConsumableStatus = false
          this.$message.success("添加成功")
          this.getLists()
        })
      },
      // 删除易耗品基础资料
      deleteConsumable(row) {
        this.$confirm('此操作将永久删除该易耗品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/consumable/del', {
            consumableId: row.id
          }, (res) => {
            this.$message.success("删除易耗品成功")
            this.getLists()
          })
        }).catch(() => {});
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _new.number.indexOf(this.filterKey) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/consumable/list', {
          depId: 2
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      filterKey() {
        this.getFilterData()
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/consumable/consumableList.vue